import {
  comboboxActions,
  findNode,
  getEditorString,
  getPlugin,
  setNodes,
} from '@udecode/plate';
import { BufferEditor, BufferValue } from '~/editor/BufferEditor/types.plate';
import { AutocompletePluginOptions } from '..';
import {
  AutocompleteInputElement,
  AutocompleteInputElementInterface,
} from '../nodes';
import { getMentionTextRange } from '../queries';
import { mentionContainsInvalidCharacter } from '../transforms/mentionContainsInvalidCharacter';

export const onMentionUpdated = <E extends AutocompleteInputElement>(
  editor: BufferEditor,
  elementInterface?: AutocompleteInputElementInterface<E>
) => {
  if (!elementInterface) return;

  const {
    options: { fetchNewSuggestions },
  } = getPlugin<AutocompletePluginOptions<E>, BufferValue>(
    editor,
    elementInterface.type
  );

  const mentionNodeEntry = findNode(editor, {
    match: (n) => elementInterface.is(n),
  });

  if (mentionNodeEntry) {
    const [node] = mentionNodeEntry;
    const containsInvalidCharacter = mentionContainsInvalidCharacter(
      editor,
      elementInterface,
      mentionNodeEntry
    );

    if (node.autocompleted) {
      setNodes(
        editor,
        { autocompleted: false },
        { match: (n) => elementInterface.is(n) }
      );
    }

    if (containsInvalidCharacter) {
      comboboxActions.reset();
    }

    if (fetchNewSuggestions && !containsInvalidCharacter) {
      comboboxActions.open({
        activeId: elementInterface.type,
        text: getEditorString(editor, mentionNodeEntry[1]),
        targetRange: getMentionTextRange(editor, elementInterface),
      });
      fetchNewSuggestions(editor);
    }
  }
};
